/**
 * 遊戲主入口
 * 初始化Phaser遊戲實例並設置所有遊戲狀態
 */
import PIXI from 'expose-loader?PIXI!phaser-ce/build/custom/pixi.js';
import p2 from 'expose-loader?p2!phaser-ce/build/custom/p2.js';
import Phaser from 'expose-loader?Phaser!phaser-ce/build/custom/phaser-split.js';

import Boot from "./states/Boot.js";
import Preload from "./states/Preload.js";
import Game from "./states/Game.js";
import StartScreen from "./states/StartScreen.js";
import { GameConfig } from "./config/gameConfig.js";

// 遊戲配置
const gameConfig = {
  width: GameConfig.WIDTH,
  height: GameConfig.HEIGHT,
  multiTexture: true,
  parent: 'game', // 與 index.html 中的 #game 容器匹配
  enableDebug: false,
  renderer: Phaser.WEBGL_MULTI
};

// 創建Phaser遊戲實例
const game = new Phaser.Game(gameConfig);
game.clearBeforeRender = false;

// 註冊所有遊戲狀態
game.state.add('boot', Boot);
game.state.add('preload', Preload);
game.state.add('start', StartScreen);
game.state.add('game', Game);

// 啟動遊戲（從boot狀態開始）
game.state.start('boot');
